module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('category.label')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.from.category),
      expression: "item.from.category"
    }],
    staticClass: "form-select",
    attrs: {
      "columns": 3,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.item.from.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.from, "category", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.item.to.categories), function(category, index) {
    return _c('form-group', {
      key: category,
      attrs: {
        "label": ((_vm.$t('category.label')) + " " + (_vm.$t('level.label')) + " " + ((index + 1))),
        "columns": 6
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.itemsNames[category]),
        expression: "itemsNames[category]"
      }],
      staticClass: "form-select",
      attrs: {
        "readonly": "readonly"
      },
      domProps: {
        "value": (_vm.itemsNames[category])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.itemsNames, category, $event.target.value)
        }
      }
    })])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-col-2@md vertical-center"
  }, [_vm._t("default"), _vm._v(" "), (_vm.categoryNotFound) ? _c('div', {
    staticClass: "hint hint--left icon-category-not-found",
    attrs: {
      "data-label": "Uma ou mais categorias desse mapeamento foram removidas do Mercado Livre, por favor remova e refaça o mapeamento."
    }
  }, [_c('i', {
    staticClass: "icon-warning2 t-warning"
  })]) : _vm._e()], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-col-1@md vertical-center"
  }, [_c('i', {
    staticClass: "i-arrow icon-arrow-right center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e231f02e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/ecommerce/moovin/marketplace/mercadoLivre/CategorizationItem.vue
// module id = 3460
// module chunks = 0